import { AttributeValueInput } from "./types";

// Placeholder attribute ID used for TODOs
const PLACEHOLDER_ATTRIBUTE_ID = 999999;

/**
 * Filters out placeholder attribute mappings (ID: 999999) to prevent
 * them from being submitted to production.
 * 
 * These placeholders are used in the codebase to indicate where proper
 * attribute IDs need to be added once they're available from the backend.
 */
export function filterPlaceholderAttributes(attributes: AttributeValueInput[]): AttributeValueInput[] {
  return attributes.filter(attr => attr.attributeDefinitionId !== PLACEHOLDER_ATTRIBUTE_ID);
}

/**
 * Checks if an attribute ID is a placeholder
 */
export function isPlaceholderAttribute(attributeId: number): boolean {
  return attributeId === PLACEHOLDER_ATTRIBUTE_ID;
}